import { render, staticRenderFns } from "./RightMenuCart_Ap.vue?vue&type=template&id=2d6e1c3c&scoped=true"
import script from "./RightMenuCart_Ap.vue?vue&type=script&lang=js"
export * from "./RightMenuCart_Ap.vue?vue&type=script&lang=js"
import style0 from "./RightMenuCart_Ap.vue?vue&type=style&index=0&id=2d6e1c3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e1c3c",
  null
  
)

export default component.exports